<!-- eslint-disable -->
<template>



    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Архив товаров</h3>
                    </div>
                    <div class="card-body pt-0">

                        <b-button v-b-toggle.filter-products variant="primary">Открыть фильтр</b-button>
                        <b-collapse id="filter-products" class="mt-5">

                            <div class="mb-10">
                                <div class="row align-items-center">
                                    <div class="col-lg-12 col-xl-12">
                                        <div class="row align-items-center">

                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="category">Поиск по имени или артикулу</label>
                                                <div class="input-icon">
                                                    <input v-model="filter.search" type="text" class="form-control form-control-solid" placeholder="Поиск.." id="kt_datatable_search_query" />
                                                    <span><i class="flaticon2-search-1 text-muted"></i></span>
                                                </div>
                                            </div>


                                           <!-- <div class="col-md-4 my-2 my-md-0">
                                                <label for="category">Категория</label>
                                                <select v-model="filter.category" class="form-control form-control-solid" id="category">
                                                    <option :value="null">Нет</option>
                                                    <template v-for="(category, i) in categories" >
                                                        <option v-bind:key="i" :value="category.id">{{category.name}}</option>
                                                    </template>
                                                </select>
                                            </div>

                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="category">Подкатегория</label>
                                                <select v-model="filter.sub_category" class="form-control form-control-solid" id="sub_category">
                                                    <option :value="null">Нет</option>
                                                    <template v-if="subcategories" v-for="(category, i) in subcategories" >
                                                        <option v-bind:key="i" :value="category.id">{{category.name}}</option>
                                                    </template>
                                                </select>
                                            </div>-->
                                        </div>
                                        <div class="row align-items-center mt-3">
                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="category">Цена от</label>
                                                <input class="form-control form-control-solid"
                                                       type="text"
                                                       v-model="filter.price_from">
                                            </div>
                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="category">Цена до</label>
                                                <input class="form-control form-control-solid"
                                                       type="text"
                                                       v-model="filter.price_to">
                                            </div>
                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="status">Статус</label>
                                                <select v-model="filter.status" class="form-control form-control-solid" id="status">
                                                    <option :value="null">Выбрать</option>

                                                    <option value="1">В наличии</option>
                                                    <option value="0">Предзаказ</option>

                                                </select>
                                            </div>
                                        </div>
                                        <div class="row align-items-center mt-3">
                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="category">Количество от</label>
                                                <input class="form-control form-control-solid"
                                                       type="text"
                                                       v-model="filter.stock_from">
                                            </div>
                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="category">Количество до</label>
                                                <input class="form-control form-control-solid"
                                                       type="text"
                                                       v-model="filter.stock_to">
                                            </div>
                                            <div class="col-md-4 my-2 my-md-0">
                                                <label for="sort">Сортировка по</label>
                                                <select v-model="filter.sort" class="form-control form-control-solid" id="sort">

                                                    <option value="data-new">По дате (новые)</option>
                                                    <option value="data-old">По дате (старые)</option>
                                                    <option value="price-high">По цене (от низкой)</option>
                                                    <option value="data-low">По цене (от высокой)</option>


                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-5">
                                        <b-button @click="getFilter" class="mr-3" variant="primary">Применить</b-button>

                                        <a @click="resetFilter" class="btn btn-light-primary  font-weight-bold">
                                            Сбросить
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </b-collapse>



                        <div v-if="products.length === 0" class="text-center mb-10">
                            Товары не найдены! <a href="#" @click="resetFilter">Сбросьте фильтры</a>
                        </div>

                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>

                        <b-form v-else>

                                <!--begin::Table-->
                                <div class="table-responsive">
                                    <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_4">
                                        <thead>
                                        <tr class="text-left">
                                            <th class="pl-0">
                                                <label class="checkbox checkbox-lg checkbox-inline mr-2">
                                                    <input type="checkbox" v-model="selectAll" />
                                                    <span></span>
                                                </label>
                                            </th>
                                            <th class="pl-0">Название</th>
                                            <th>Цена</th>
                                            <th>Категория</th>
                                            <th>Дата добавления


                                            <th>Статус</th>
                                            <th class="pr-0 text-right">Действия</th>
                                        </tr>
                                        </thead>


                                        <tbody>
                                        <template v-for="(product, i) in products">
                                            <tr>
                                                <td class="pl-0 py-6">
                                                    <label class="checkbox checkbox-lg checkbox-inline">
                                                        <input type="checkbox"
                                                               v-model="selected"
                                                               :value="product.id"
                                                        />
                                                        <span></span>
                                                    </label>
                                                </td>
                                                <td class="pl-0">
                                                    <div class="d-flex align-items-center">
                                                        <div class="symbol symbol-50 flex-shrink-0 mr-4">
                                                            <div class="symbol-label"
                                                                 :style="{ backgroundImage: 'url(' + $urlBackEnd(product.images[0].thumbnail) + ')' }"></div>
                                                        </div>

                                                        <div>
                                                            <a class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{product.title}}</a>
                                                            <span class="text-muted font-weight-bold d-block">Артикул: {{product.sku}}, {{product.stock}} шт.</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span class="text-primary font-weight-bolder d-block font-size-lg">
                                                        {{ numberWithSpaces(product.price) }} руб.
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="product.categories.length > 0" class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                        <template v-for="category in product.categories">
                                                            {{category.name}} <br>
                                                        </template>
                                                    </span>
                                                    <span v-else class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                                        Нет категории
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="text-primary font-weight-bolder d-block font-size-lg">
                                                        {{ moment(product.created_at).format('ll') }}
                                                    </span>
                                                    <span class="text-muted font-weight-bold">
                                                        {{ moment(product.created_at).startOf('day').fromNow() }}
                                                    </span>
                                                </td>

                                                <td>
                                                    <span v-if="product.type === 'in_stock'" class="label label-lg label-light-primary label-inline">В наличии</span>
                                                    <span v-if="product.type === 'for_order'" class="label label-lg label-light-warning label-inline">Предзаказ</span>
                                                </td>
                                                <td class="pr-0 text-right">
                                                    <b-link @click="restoreProduct(product.id)" v-b-tooltip.hover title="Восстановить товар" class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"><i class="fas fa-trash-restore"></i></b-link>
                                                    <b-link v-if="$can('deletion')" @click="showModal(product.title,  product.id)" v-b-tooltip.hover title="Удалить навсегда" class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"><i class="fas fa-ban"></i></b-link>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                                <!--end::Table-->

                        <div class="row align-items-center mb-3">
                            <div class="col-lg-12 col-xl-12">
                                <div class="row align-items-center">
                                    <div class="col-md-4 my-2 my-md-0">
                                        <b-form-select
                                                class="mb-2 mr-sm-2 mb-sm-0"
                                                :value="null"
                                                v-model="actions"
                                        >


                                                <option :value="null">Выберите действие</option>
                                                <option value="restore">Восстановить выбранные товары</option>
                                                <option v-if="$can('deletion')" value="dest">Удалить выбранные товары навсегда</option>

                                        </b-form-select>
                                    </div>
                                    <div class="col-md-4 my-2 my-md-0">
                                        <b-button @click="moreActions" variant="primary">Применить</b-button>
                                    </div>

                                </div>
                            </div>
                        </div>

                            <Paginate :route_link="'ArchiveProducts'" :filter="filter" />

                        </b-form>


                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="delete-modal" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Уничтожить товар: "{{modalProduct.title}}" навсегда?</h3>
                <p>Внимание: Товар невозможно будет восстановить.</p>
            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideModal">Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="outline-danger" block @click="destroyProduct(modalProduct.id)">Уничтожить</b-button>
                </b-col>
            </b-row>

        </b-modal>

        <b-modal ref="mass-delete-modal" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Уничтожить выбранные товары навсегда?</h3>
                <p>Внимание: Товары невозможно будет восстановить.</p>
            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideDestroyModal">Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="outline-danger" block @click="moreDestroyProduct">Уничтожить</b-button>
                </b-col>
            </b-row>

        </b-modal>


    </div>
</template>

<script>

    import moment from "moment";
    require('moment/locale/ru');

    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {
        GET_PRODUCTS,
        RESTORE_PRODUCT,
        FORCE_DELETE_PRODUCT,
        MORE_RESTORE_PRODUCTS,
        MORE_FORCE_DELETE_PRODUCT
    } from "@/core/services/store/products.module";
    import {GET_SELECT, GET_SELECT_SUB} from "@/core/services/store/categories.module";
    import {SET_ALERT} from "@/core/services/store/alert.module";
    import Paginate from "../Paginate";
    export default {
        name: "Products",
        components: {Paginate},
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Архив товаров" }]);
            this.getFilter();
            this.$store.dispatch(GET_SELECT)
        },
        computed: {
            ...mapGetters({
                products: 'gettersProducts',
                load: 'getProductLoad',
                paginate: 'paginateGetters',
                categories: 'getSelectCategory',
                subcategories: 'getSelectSubCategory',
            }),

            selectAll: {
                get: function () {
                    return this.products ? this.selected.length == this.products.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.products.forEach(function (products) {
                            selected.push(products.id);
                        });
                    }

                    this.selected = selected;
                }
            }

        },

        methods:{
            addProduct(){
                this.$router.push({ name: "AddProduct" })
            },

            numberWithSpaces(x){
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            },

            async getFilter(){
                try {
                    await this.$store.dispatch(GET_PRODUCTS, {'page': this.$route.params.page, 'filter': this.filter});
                    if (this.products.length === 0 && this.paginate.total > 0){
                        this.$router.push({ name: 'ArchiveProducts', params: {page: 1}})
                    }
                } catch (e) {
                    this.showAlert('Ошибка загрузки', 'danger', 'toast');
                }
            },

            resetFilter(){
                const reset_filter = {
                    to: '50',
                    price_from: '',
                    price_to: '',
                    new: false,
                    sale: false,
                    search: '',
                    category: null,
                    sub_category: null,
                    status: null,
                    stock_from: '',
                    stock_to: '',
                    sort: 'data-new',
                    trashed: true
                };

                this.filter = reset_filter;

                this.getFilter()
            },

            makeToast(variant = null) {
                this.$bvToast.toast('Toast body content', {
                    title: `Variant ${variant || 'default'}`,
                    variant: variant,
                    solid: true
                })
            },

            restoreProduct(id){
                this.$store.dispatch(RESTORE_PRODUCT, id)
                    .then(() => {
                        this.getFilter();
                        this.showAlert('Товар успешно восстановлен', 'success', 'toast');
                    })
                    .catch(() => {
                        this.showAlert('Ошибка восстановления', 'danger', 'toast');
                    })
            },

            destroyProduct(id){
                this.$store.dispatch(FORCE_DELETE_PRODUCT, id)
                    .then(() => {
                        this.getFilter();
                        this.showAlert('Товар успешно уничтожен', 'success', 'toast');
                    })
                    .catch(() => {
                        this.showAlert('Ошибка удаления', 'danger', 'toast');
                    })
                    .finally(() => {
                        this.hideModal()
                    })
            },

            moreDestroyProduct(){
               this.$store.dispatch(MORE_FORCE_DELETE_PRODUCT, this.selected)
                   .then(() => {
                       this.getFilter();
                       this.showAlert('Товары успешно уничтожены', 'success', 'toast');
                   })
                   .catch(() => {
                       this.showAlert('Ошибка удаления', 'danger', 'toast');
                   })
                   .finally(() => {
                       this.hideDestroyModal()
                   })
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            showModal(title, id) {
                this.modalProduct = {
                    'title': title,
                    'id': id
                };
                this.$refs['delete-modal'].show()
            },

            showDestroyModal() {
                this.$refs['mass-delete-modal'].show()
            },

            hideDestroyModal() {
                this.$refs['mass-delete-modal'].hide()
            },

            hideModal() {
                this.modalProduct = {};
                this.$refs['delete-modal'].hide()
            },


            moreActions(){

                if (this.actions === null){
                    this.showAlert('Необходимо выбрать действие', 'warning', 'toast');
                    return false
                }

                if (this.selected.length === 0){
                    this.showAlert('Необходимо выбрать хотя бы один товар', 'warning', 'toast');
                    return false
                }


                if (this.actions === "restore" && this.selected.length > 0){
                    this.$store.dispatch(MORE_RESTORE_PRODUCTS, this.selected)
                        .then(() => {
                            this.getFilter();
                            this.showAlert('Товары успешно восстановлены', 'success', 'toast');
                        })
                        .catch(() => {
                            this.showAlert('Ошибка восстановления', 'danger', 'toast');
                        })

                } else if (this.actions === "dest" && this.selected.length > 0 ) {

                    this.showDestroyModal()

                }

            }


        },

        data(){
            return{
                moment:moment,

                filter: {
                    to: '50',
                    price_from: '',
                    price_to: '',
                    new: false,
                    sale: false,
                    search: '',

                    category: null,
                    sub_category: null,
                    status: null,

                    stock_from: '',
                    stock_to: '',

                    sort: 'data-new',
                    trashed: true,
                },

                modalProduct: {},

                selected: [],
                actions: null
            }
        },

        watch: {
            $route: function () {
                this.getFilter()
            },

            "filter.to": function() {
                this.getFilter()
            },

            "filter.category": function() {
                const sub = {
                    'sub': this.filter.category
                };
                this.$store.dispatch(GET_SELECT_SUB, sub)
            }
        },


    }
</script>

<style scoped>

</style>